module.exports = __webpack_public_path__ + "38932fe58a0acb7fea104c83a7cab7cc.png";